module.exports = __webpack_public_path__ + "img/p2-gray.174ad049.png";